import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Input from 'components/input/input';

import { useOutsideClick } from 'helpers/clickOutside';

const TableCellTextEdit = ({ label, value: v, onTextUpdate, readOnly }) => {
  const menuRef = useRef(null);
  const [value, setValue] = useState(v);
  const [showDropdown, setShowDropdown] = useState(false);

  useOutsideClick(menuRef, () => setShowDropdown(false));

  const onToggleDropdown = (e) => {
    if (e.target.type !== 'text' && !readOnly) setShowDropdown(!showDropdown);
  };

  const onUpdate = () => {
    onTextUpdate(value);
    setShowDropdown(false);
  };

  const containerClasses = classNames('th-list-data', {
    pointer: !readOnly,
  });

  return (
    <div ref={menuRef} className={containerClasses} onClick={onToggleDropdown}>
      <div className="flex justify-between">
        <p className="apps-card-app-desc">{value}</p>
      </div>
      {showDropdown && (
        <div
          className="th-select-filter-dropdown"
          id="th-cell-text-edit"
          style={{
            width: document.getElementById('th-cell-header').offsetWidth * 2,
            marginTop: '5px',
          }}
        >
          <div className="pr5 pl5 flex justify-between">
            <div className="w-100 mt2 flex flex-row items-center">
              <Input
                label={label}
                value={value}
                valid={true}
                onChange={(e) => setValue(e.target.value)}
              />
            </div>
          </div>
          <div className="tc mb2">
            <button className="btn-green" onClick={onUpdate}>
              <span>Update</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

TableCellTextEdit.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onTextUpdate: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

export default TableCellTextEdit;
